/**
 * pages/DashboardPage.tsx — CLI-450
 * Главная страница кабинета: приветствие + карточки быстрого доступа.
 */
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth.store';
import { getNotifications } from '../services/patient.service';

const QUICK_LINKS = [
  { to: '/portal/documents',    label: 'Документы',         icon: '📄', desc: 'Заключения и справки' },
  { to: '/portal/lab',          label: 'Анализы',           icon: '🧪', desc: 'Результаты лаборатории' },
  { to: '/portal/studies',      label: 'Исследования',      icon: '🩻', desc: 'МРТ, КТ, УЗИ и другие' },
  { to: '/portal/appointments', label: 'Мои записи',        icon: '📅', desc: 'Предстоящие визиты' },
  { to: '/portal/book',         label: 'Записаться',        icon: '➕', desc: 'На приём или анализы' },
];

export function DashboardPage() {
  const { patient } = useAuthStore();
  const { data: notifData } = useQuery({
    queryKey: ['patient-notifications'],
    queryFn: getNotifications,
    staleTime: 60_000,
  });

  const unread = notifData?.meta.unread ?? 0;

  return (
    <div className="p-4 space-y-4">
      {/* Приветствие */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl p-5 text-white">
        <p className="text-primary-200 text-sm mb-1">Добрый день,</p>
        <h2 className="text-xl font-bold">
          {patient?.firstName} {patient?.lastName}
        </h2>
        {unread > 0 && (
          <Link to="/portal/notifications" className="mt-2 inline-flex items-center gap-1 text-xs bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full transition">
            🔔 {unread} новых уведомлений
          </Link>
        )}
      </div>

      {/* Быстрый доступ */}
      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide">Разделы</h3>
      <div className="grid grid-cols-2 gap-3">
        {QUICK_LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition flex flex-col gap-1"
          >
            <span className="text-2xl">{link.icon}</span>
            <span className="font-semibold text-gray-800 text-sm">{link.label}</span>
            <span className="text-xs text-gray-500">{link.desc}</span>
          </Link>
        ))}
      </div>

      {/* Безопасность */}
      <div className="text-center text-xs text-gray-400 pt-2">
        🔒 Данные защищены согласно ФЗ-152 и ФЗ-323
      </div>
    </div>
  );
}
